<template>
  <span>
    <b-modal v-model="modal" @hide="hideModal" title="Merma">
      <div class="text-center">
        <b-alert show
          >CREANDO DESDE {{ lotComputed }}-{{ product_name }}<br /><b
            >{{ differenceComputed }} Kg RESTANTES</b
          ></b-alert
        >
      </div>
      <b-row>
        <b-col>
          <b-form-group
            label-cols-sm="6"
            label-cols-lg="6"
            label="Orden Fabricación"
          >
            <b-form-input
              type="text"
              required
              autocomplete="off"
              v-model="$v.form.manufacturing_order.$model"
              :state="
                $v.form.manufacturing_order.$dirty
                  ? !$v.form.manufacturing_order.$error
                  : null
              "
              v-on:keyup="inputSoloNumero"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="fieldset-horizontal"
            label-cols-sm="6"
            label-cols-lg="6"
            label="Recipiente"
            label-for="input-horizontal"
          >
            <search-select
              v-model="$v.form.container.$model"
              :submitStatus="submitActive"
              :validation="$v.form.container"
              url="/bagno/container/select_container/"
            />
            <b-form-text v-if="form.container.text" class="ml-2"
              >Actualmente seleccionado:
              <b class="font-size-3">{{ form.container.text }}</b></b-form-text
            >
          </b-form-group>
          <b-form-group
            id="fieldset-horizontal"
            label-cols-sm="6"
            label-cols-lg="6"
            label="Cantidad"
            label-for="input-horizontal"
          >
            <b-form-input
              type="text"
              v-model="$v.form.quantity.$model"
              :state="$v.form.quantity.$dirty ? !$v.form.quantity.$error : null"
              @focus="form.quantity = null"
              step="1"
              v-on:keyup="inputSoloNumero"
              autocomplete="off"
              id="input-horizontal"
            />
          </b-form-group>
          <b-form-group
            id="fieldset-horizontal"
            label-cols-sm="6"
            label-cols-lg="6"
            label="Peso pallet"
            label-for="input-horizontal"
          >
            <b-form-input
              type="text"
              v-model="$v.form.pallet_weight.$model"
              :state="
                $v.form.pallet_weight.$dirty
                  ? !$v.form.pallet_weight.$error
                  : null
              "
              step="0.01"
              @focus="form.pallet_weight = null"
              v-on:keyup="inputSoloNumeroDecimal"
              autocomplete="off"
              id="input-horizontal"
            />
          </b-form-group>
          <b-form-group
            id="fieldset-horizontal"
            label-cols-sm="6"
            label-cols-lg="6"
            label-for="input-horizontal"
          >
            <template slot="label">
              Peso bruto
              <a
                href="#"
                v-if="materialWeightSum > 0"
                @click.prevent="squareGross"
                >Cuadrar c/ diferencia</a
              >
            </template>
            <b-form-input
              type="text"
              v-model="$v.form.gross_weight.$model"
              :state="
                $v.form.gross_weight.$dirty
                  ? !$v.form.gross_weight.$error
                  : null
              "
              @focus="form.gross_weight = null"
              v-on:keyup="inputSoloNumeroDecimal"
              step="0.01"
              autocomplete="off"
              id="input-horizontal"
            />
          </b-form-group>
          <b-form-group
            id="fieldset-horizontal"
            label="Peso Neto"
            label-cols-sm="6"
            label-cols-lg="6"
            label-for="input-horizontal"
          >
            <b-form-input
              type="number"
              disabled
              :value="netWeight"
              id="input-horizontal"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            @click.prevent="
              e => {
                e.target.blur();
                onSubmit();
              }
            "
            class="float-right ml-1"
            >Guardar
            <b-spinner v-if="loading" class="float-right" small />
          </b-button>
          <b-button class="float-right ml-1" @click="hideModal"
            >Cancelar</b-button
          >
        </div>
      </template>
    </b-modal>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import searchSelect from "../../searchSelect";
import {
  decimal,
  integer,
  required,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  name: "CreateContentMerma",
  props: {
    lot: {
      type: String,
      default: ""
    },
    lot_id: {
      type: Number,
      default: 0
    },
    fruit_id: {
      type: Number,
      default: 0
    },
    modal: {
      type: Boolean,
      default: false
    },
    product_id: {
      type: Number,
      default: 0
    },
    product_name: {
      type: String,
      default: 0
    },
    product_code: {
      type: String,
      default: 0
    },
    net_kilograms_sum_in: {
      type: String,
      default: 0
    },
    net_kilograms_sum_out: {
      type: String,
      default: 0
    }
  },
  components: {
    searchSelect
  },
  data() {
    return {
      loading: false,
      modal_title: "",
      form: {
        pallet_weight: 0,
        gross_weight: 0,
        quantity: 0,
        box_avg: 0,
        container: {
          text: null,
          material_weight: 0
        },
        manufacturing_order: null
      },
      submitActive: false
    };
  },
  computed: {
    ...mapGetters("bagnoProcessModule", [
      "totalInNet",
      "totalInGross",
      "totalOutNet",
      "totalOutGross",
      "differenceNet",
      "currentLotInProcess",
      "currentProductsInProcess",
      "checkBrechaComercial",
      "totalSaleable",
      "totalQuantitySaleable",
      "totalWaste",
      "getFruitInProcess"
    ]),
    commercialDiff() {
      return this.difference(
        this.form.box_avg * this.totalQuantitySaleable,
        this.totalSaleable
      );
    },
    netWeight() {
      return (
        this.form.gross_weight -
        this.form.pallet_weight -
        this.form.quantity * this.form.container.material_weight
      ).toFixed(2);
    },
    materialWeightSum() {
      return (
        this.form.container.material_weight * this.form.quantity +
        this.form.pallet_weight
      );
    },
    lotComputed() {
      return this.lot;
    },
    lotId() {
      return this.lot_id;
    },
    productId() {
      return this.product_id;
    },
    differenceComputed() {
      return (this.net_kilograms_sum_in - this.net_kilograms_sum_out).toFixed(
        2
      );
    }
  },
  methods: {
    hideModal() {
      this.$emit("hideMermaModal");
    },
    percentage(a, b) {
      return ((a / b) * 100).toFixed(2);
    },
    difference(a, b) {
      return (a - b).toFixed(2);
    },
    squareGross() {
      this.form.gross_weight =
        parseFloat(this.differenceNet) + this.materialWeightSum;
    },
    resetForm() {
      this.form.quantity = 0;
      this.form.pallet_weight = 0;
      this.form.gross_weight = 0;
      this.form.box_avg = 0;
      this.form.manufacturing_order = null;
    },
    async addRowsOut() {
      const thisV = this;
      thisV.loading = true;
      const data = {
        net_kilograms: thisV.netWeight,
        gross_kilograms: 0,
        container: thisV.form.container.text,
        process: thisV.$route.params.id,
        quantity: thisV.form.quantity,
        lot: thisV.lot_id,

        fruit_id: thisV.fruit_id,
        product_code: thisV.product_code,
        product_name: thisV.product_name,
        waste_type: "MERMA",
        product_id: thisV.product_id,
        is_devolution: false,
        manufacturing_order: parseInt(thisV.form.manufacturing_order)
      };

      if (parseFloat(thisV.netWeight) > parseFloat(thisV.differenceComputed)) {
        thisV.$toast.info(
          "kilos ingresados supera el total de kilos restantes disponible en el lote",
          ""
        );
        thisV.loading = false;
        thisV.submitStatus = false;
      } else {
        try {
          const response = await thisV.$axios({
            method: "POST",
            url: `bagno/process/${thisV.$route.params.id}/square_up_process/`,
            data: data
          });
          if (response.data.status != "0") {
            thisV.$store.dispatch(
              "bagnoProcessModule/addRowsOut",
              response.data
            );
            thisV.$toast.success(`MERMA creada con éxito`, "");
            thisV.loading = false;
            thisV.hideModal();
            thisV.resetForm();
          } else {
            thisV.$toast.error(
              "Problemas al crear, tipo de producto no encontrado",
              ""
            );
            thisV.loading = false;
          }
        } catch (error) {
          console.log(error);
          thisV.$toast.error("Problemas al crear", "");
          thisV.loading = false;
          thisV.resetForm();
        }
      }
    },
    onSubmit() {
      this.$v.form.$touch();
      this.submitActive = true;
      if (this.$v.$invalid == true) {
        this.$toast.info("Campos restantes en el formulario", "");
        return;
      } else {
        if (parseFloat(this.netWeight) >= 0) {
          this.addRowsOut();
        } else {
          this.$toast.warn(
            "El campo Peso Neto no puede ser negativo o igual a 0",
            ""
          );
        }
      }
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    },
    inputSoloNumeroDecimal(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/, "");
    }
  },
  validations: {
    form: {
      container: {
        text: { required },
        material_weight: { required }
      },
      quantity: { required, integer },
      pallet_weight: { required },
      gross_weight: { required },
      manufacturing_order: { required }
    }
  }
};
</script>

<style scoped></style>
